import {AssertionUtils, GridModel} from '@vdw/angular-component-library';
import {IServerSideDatasource, IServerSideGetRowsParams} from 'ag-grid-community';
import {Subject, takeUntil} from 'rxjs';
import {GetSliceRepository} from '../get-slice-repository';

export function getEntityServerSideDatasource<EntityOverview, Repository extends GetSliceRepository<EntityOverview>>(
  repository: Repository,
  unSubscribeOnViewDestroy: Subject<boolean>,
  getParameters: () => any = undefined,
  afterDataLoadFunction: () => any = undefined,
  specialFilterModel?: any
): IServerSideDatasource {
  return {
    getRows: (params: IServerSideGetRowsParams): void => {
      const startRow = params.request.startRow;
      const endRow = params.request.endRow;
      const sliceSize = endRow - startRow;
      const sortModel = params.request.sortModel;
      let filterModel = params.request.filterModel;
      if (!AssertionUtils.isNullOrUndefined(specialFilterModel)) {
        filterModel = specialFilterModel;
      }

      const gridModel: GridModel = new GridModel(startRow, endRow, sortModel, filterModel);
      const parameters = AssertionUtils.isNullOrUndefined(getParameters) ? undefined : getParameters();

      repository
        .getSlice(gridModel, parameters)
        .pipe(takeUntil(unSubscribeOnViewDestroy))
        .subscribe({
          next: (entityList: EntityOverview[]) => {
            let lastRow: number = undefined;
            if (entityList.length < sliceSize) {
              lastRow = startRow + entityList.length;
            }

            if (startRow === 0) {
              if (entityList.length === 0) {
                params.api.showNoRowsOverlay();
              } else {
                params.api.hideOverlay();
              }
            }

            params.success({
              rowData: entityList,
              rowCount: lastRow
            });

            if (!AssertionUtils.isNullOrUndefined(afterDataLoadFunction)) {
              afterDataLoadFunction();
            }
          },
          error: () => {
            params.success({
              rowData: null,
              rowCount: 0
            });

            params.api.showNoRowsOverlay();
          }
        });
    }
  };
}
